import { HelpIcon } from '@platform/components';

export const DirectoryInnerSection = ({
  title,
  tooltip,
  children,
}: {
  title: string;
  tooltip?: string;
  children: React.ReactNode;
}) => {
  return (
    <>
      <div className='hidden sm:block sm:border-t border-gray-100 sm:col-span-2' />
      <div className='border-b border-gray-100 sm:border-none'>
        <h2 className='flex gap-1 text-lg sm:text-xl text-gray-900 font-semibold sm:font-medium mb-5 sm:mb-4'>
          {title}
          {tooltip && <HelpIcon supportingText={tooltip} />}
        </h2>
      </div>
      {/* This hardcoding of the max width is unfortunate; it prevents horizontal overflow on very small screens by disallowing content to
       * stretch the container off the page, with an offset for the mobile page margins */}
      <div className='flex flex-col gap-8 sm:gap-8 max-w-[calc(100vw-32px)]'>{children}</div>
    </>
  );
};
